// extracted by mini-css-extract-plugin
export default {"category":"HeaderCashback-module__category__E-SHc"};